export function BannerToStages (banner) {
  if (!banner) return [];
  return buildStage(banner);
}

function getSteps(elements) {
  var steps = 0;
  elements.forEach(element => {
    if (element.step > steps) steps = element.step;    
  });
  return steps;
}

function buildStage(banner) {
  const maxSteps = getSteps(banner.elements);
  const stages = [];
  for (var i = 1; i <= maxSteps; i++) {
    const step = [];
    for (var j = 0; j < banner.elements.length; j++){
      var element = banner.elements[j];
      if (element.step === i) {
        step.push(element);
      }
    }
    stages.push(step);
  }
  return stages;
}

export function BuildPrintStage(banner) {
  const maxSteps = getSteps(banner.elements);
  const stages = [];
  for (var i = 1; i <= maxSteps; i++) {
    const step = [];
    for (var j = 0; j < banner.elements.length; j++){
      var element = banner.elements[j];
      if (element.step <= i && (element.stepout > i || element.fixo) && element.enabled) {
        step.push(element);
      }
    }
    stages.push(step);
  }
  return stages;
}